import React, {Component, Fragment} from "react";
import Acceuil from "./Accueil/Accueil";
import Localisation from "./Localisation/Localisation";
import Localisation75 from "./Localisation75/Localisation75";
import Localisation77 from "./Localisation77/Localisation77";
import Localisation78 from "./Localisation78/Localisation78";
import Localisation91 from "./Localisation91/Localisation91";
import Localisation92 from "./Localisation92/Localisation92";
import Localisation93 from "./Localisation93/Localisation93";
import Localisation94 from "./Localisation94/Localisation94";
import Localisation95 from "./Localisation95/Localisation95";
import Contact from "./Contact/Contact";
import NavBar from "../../components/UI/NavBar/NavBar";
import {Route,Switch} from "react-router-dom";
import Container from "react-bootstrap/Container";
import Route404 from "../../components/Route404/Route404";
import Footer from "../../components/Footer/Footer";


class Site extends Component {
    render() {
        return (
            <Fragment>
            <div className="site">
                <NavBar/>
                <Container>
                    <Switch>
                        <Route path="/" exact render={()=> <Acceuil/>}/>
                        <Route path="/localisation" render={()=> <Localisation/>}/>
                        <Route path="/localisation75" render={()=> <Localisation75/>}/>
                        <Route path="/localisation77" render={()=> <Localisation77/>}/>
                        <Route path="/localisation78" render={()=> <Localisation78/>}/>
                        <Route path="/localisation91" render={()=> <Localisation91/>}/>
                        <Route path="/localisation92" render={()=> <Localisation92/>}/>
                        <Route path="/localisation93" render={()=> <Localisation93/>}/>
                        <Route path="/localisation94" render={()=> <Localisation94/>}/>
                        <Route path="/localisation95" render={()=> <Localisation95/>}/>
                        <Route path="/contact" render={(props)=> <Contact {...props} />}/>
                        <Route render={()=> <Route404/>}/>
                    </Switch>
                </Container>
                <div className="minSite"></div>
            </div>    
                <Footer/>
            </Fragment>
        );
    }
}
export default Site;